function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-use-before-define */
import { rdf } from '@tpluscode/rdf-ns-builders';
import { createProxy } from "./proxy.mjs";
export default class {
  constructor(baseClass) {
    _defineProperty(this, "__mixins", new Set());

    _defineProperty(this, "__alwaysMixins", new Set());

    _defineProperty(this, "__typeMixins", new Map());

    _defineProperty(this, "__typeCache", new Map());

    _defineProperty(this, "BaseClass", void 0);

    this.BaseClass = baseClass;
  }

  addMixin(...mixins) {
    this.__typeCache.clear();

    mixins.forEach(mixin => {
      if ('appliesTo' in mixin) {
        const current = this.__typeMixins.get(mixin.appliesTo.value) || [];

        this.__typeMixins.set(mixin.appliesTo.value, [...current, mixin]);
      } else {
        if (mixin.shouldApply === true) {
          this.__alwaysMixins.add(mixin);
        }

        this.__mixins.add(mixin);
      }
    });
  }

  createEntity(pointer, typeAndMixins = [], options = {}) {
    let BaseClass = this.BaseClass;
    let explicitMixins = typeAndMixins;

    if (typeAndMixins.length > 0) {
      const [BaseClassOrMixin, ...rest] = typeAndMixins;

      if ('factory' in BaseClassOrMixin) {
        BaseClass = BaseClassOrMixin;
        explicitMixins = rest;
      }
    }

    const types = pointer.out(rdf.type).values;

    for (const type of ((_options$initializer = options.initializer) === null || _options$initializer === void 0 ? void 0 : _options$initializer.types) || []) {
      var _options$initializer;

      if ('termType' in type) {
        types.push(type.value);
      } else {
        types.push(type.id.value);
      }
    }

    BaseClass = this.__getBaseClass(BaseClass, types);
    const entity = new BaseClass(pointer);
    const mixins = [...this.__mixins].reduce((selected, next) => {
      if (next.shouldApply === true || typeof next.shouldApply === 'function' && next.shouldApply(entity)) {
        selected.add(next);
      }

      return selected;
    }, new Set(explicitMixins));

    const Type = this.__extend(BaseClass, [...mixins]);

    Type.factory = this;
    return createProxy(new Type(pointer, options.initializer, options.parent));
  }

  __getBaseClass(baseClass, types) {
    const cacheKey = [baseClass.name, ...types].toString();

    const cached = this.__typeCache.get(cacheKey);

    if (cached) {
      return cached;
    }

    const rdfTypeMixins = types.reduce((mixins, type) => {
      const typeMixins = this.__typeMixins.get(type);

      if (typeMixins) {
        typeMixins.forEach(m => mixins.add(m));
      }

      return mixins;
    }, new Set());

    const type = this.__extend(baseClass, [...this.__alwaysMixins, ...rdfTypeMixins]);

    this.__typeCache.set(cacheKey, type);

    return type;
  }

  __extend(baseClass, mixins) {
    const type = mixins.reduce((Mixed, Next) => Next(Mixed), baseClass);
    const baseMixins = baseClass.__mixins || [];
    type.__mixins = [...baseMixins, ...mixins];
    return type;
  }

}